/* eslint-disable */
tinymce.addI18n('ar', {
  Redo: '\u0625\u0639\u0627\u062f\u0629',
  Undo: '\u062a\u0631\u0627\u062c\u0639',
  Cut: '\u0642\u0635',
  Copy: '\u0646\u0633\u062e',
  Paste: '\u0644\u0635\u0642',
  'Select all': '\u062a\u062d\u062f\u064a\u062f \u0627\u0644\u0643\u0644',
  'New document': '\u0645\u0633\u062a\u0646\u062f \u062c\u062f\u064a\u062f',
  Ok: '\u0645\u0648\u0627\u0641\u0642',
  Cancel: '\u0625\u0644\u063a\u0627\u0621',
  'Visual aids':
    '\u0627\u0644\u0645\u0639\u064a\u0646\u0627\u062a \u0627\u0644\u0628\u0635\u0631\u064a\u0629',
  Bold: '\u063a\u0627\u0645\u0642',
  Italic: '\u0645\u0627\u0626\u0644',
  Underline: '\u062a\u0633\u0637\u064a\u0631',
  Strikethrough: '\u064a\u062a\u0648\u0633\u0637 \u062e\u0637',
  Superscript: '\u0645\u0631\u062a\u0641\u0639',
  Subscript: '\u0645\u0646\u062e\u0641\u0636',
  'Clear formatting': '\u0645\u0633\u062d \u0627\u0644\u062a\u0646\u0633\u064a\u0642',
  'Align left':
    '\u0645\u062d\u0627\u0630\u0627\u0629 \u0627\u0644\u0646\u0635 \u0644\u0644\u064a\u0633\u0627\u0631',
  'Align center': '\u062a\u0648\u0633\u064a\u0637',
  'Align right':
    '\u0645\u062d\u0627\u0630\u0627\u0629 \u0627\u0644\u0646\u0635 \u0644\u0644\u064a\u0645\u064a\u0646',
  Justify: '\u0636\u0628\u0637',
  'Bullet list': '\u062a\u0639\u062f\u0627\u062f \u0646\u0642\u0637\u064a',
  'Numbered list': '\u062a\u0631\u0642\u064a\u0645',
  'Decrease indent':
    '\u0625\u0646\u0642\u0627\u0635 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062f\u0626\u0629',
  'Increase indent':
    '\u0632\u064a\u0627\u062f\u0629 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062f\u0626\u0629',
  Close: '\u0625\u063a\u0644\u0627\u0642',
  Formats: '\u0627\u0644\u062a\u0646\u0633\u064a\u0642\u0627\u062a',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    '\u0645\u062a\u0635\u0641\u062d\u0643 \u0644\u0627 \u064a\u062f\u0639\u0645 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0625\u0644\u0649 \u0627\u0644\u062d\u0627\u0641\u0638\u0629. \u0627\u0644\u0631\u062c\u0627\u0621 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u062e\u062a\u0635\u0627\u0631\u0627\u062a \u0644\u0648\u062d\u0629 \u0627\u0644\u0645\u0641\u0627\u062a\u064a\u062d Ctrl+X/C/V \u0628\u062f\u0644\u0627 \u0645\u0646 \u0630\u0644\u0643.',
  Headers: '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646',
  'Header 1': '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646 1',
  'Header 2': '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646 2',
  'Header 3': '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646 3',
  'Header 4': '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646 4',
  'Header 5': '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646 5',
  'Header 6': '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646 6',
  Headings:
    '\u0627\u0644\u0639\u0646\u0627\u0648\u064a\u0646 \u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629',
  'Heading 1': '\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0626\u064a\u0633\u064a 1',
  'Heading 2': '\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0626\u064a\u0633\u064a 2',
  'Heading 3': '\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0626\u064a\u0633\u064a 3',
  'Heading 4': '\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0626\u064a\u0633\u064a 4',
  'Heading 5': '\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0626\u064a\u0633\u064a 5',
  'Heading 6': '\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0626\u064a\u0633\u064a 6',
  Preformatted: '\u0645\u0647\u064a\u0623 \u0645\u0633\u0628\u0642\u0627',
  Div: 'Div',
  Pre: '\u0633\u0627\u0628\u0642',
  Code: '\u0631\u0645\u0632',
  Paragraph: '\u0641\u0642\u0631\u0629',
  Blockquote: '\u0639\u0644\u0627\u0645\u0627\u062a \u0627\u0644\u0627\u0642\u062a\u0628\u0627\u0633',
  Inline: '\u062e\u0644\u0627\u0644',
  Blocks: '\u0627\u0644\u0623\u0642\u0633\u0627\u0645',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.':
    '\u064a\u062a\u0645 \u0627\u0644\u0644\u0635\u0642 \u062d\u0627\u0644\u064a\u0627\u064b \u0643\u0646\u0635 \u0639\u0627\u062f\u064a. \u0627\u0644\u0645\u062d\u062a\u0648\u0649 \u0633\u064a\u0628\u0642\u0649 \u0643\u0646\u0635 \u0639\u0627\u062f\u064a \u062d\u062a\u0649 \u062a\u0642\u0648\u0645 \u0628\u062a\u0639\u0637\u064a\u0644 \u0647\u0630\u0627 \u0627\u0644\u062e\u064a\u0627\u0631.',
  'Font Family': '\u0645\u062c\u0645\u0648\u0639\u0629 \u0627\u0644\u062e\u0637',
  'Font Sizes': '\u062d\u062c\u0645 \u0627\u0644\u062e\u0637',
  Class: '\u0627\u0644\u0641\u0626\u0629',
  'Browse for an image': '\u0627\u0633\u062a\u0639\u0631\u0627\u0636 \u0635\u0648\u0631\u0629',
  OR: '\u0623\u0648',
  'Drop an image here': '\u0627\u0633\u0642\u0637 \u0627\u0644\u0635\u0648\u0631\u0629 \u0647\u0646\u0627',
  Upload: '\u0631\u0641\u0639',
  Block: '\u0642\u0633\u0645',
  Align: '\u0645\u062d\u0627\u0630\u0627\u0629 \u0623\u0641\u0642\u064a\u0629',
  Default: '\u0627\u0644\u0627\u0641\u062a\u0631\u0627\u0636\u064a',
  Circle: '\u062f\u0627\u0626\u0631\u0629',
  Disc: '\u0642\u0631\u0635',
  Square: '\u0645\u0631\u0628\u0639',
  'Lower Alpha': '\u062a\u0631\u0642\u064a\u0645 \u0623\u062e\u0631\u0641 \u0635\u063a\u064a\u0631\u0629',
  'Lower Greek':
    '\u062a\u0631\u0642\u064a\u0645 \u064a\u0648\u0646\u0627\u0646\u064a \u0635\u063a\u064a\u0631',
  'Lower Roman':
    '\u062a\u0631\u0642\u064a\u0645 \u0631\u0648\u0645\u0627\u0646\u064a \u0635\u063a\u064a\u0631',
  'Upper Alpha': '\u062a\u0631\u0642\u064a\u0645 \u0623\u062d\u0631\u0641 \u0643\u0628\u064a\u0631\u0629',
  'Upper Roman':
    '\u062a\u0631\u0642\u064a\u0645 \u0631\u0648\u0645\u0627\u0646\u064a \u0643\u0628\u064a\u0631',
  Anchor: '\u0645\u0631\u0633\u0627\u0629',
  Name: '\u0627\u0644\u0627\u0633\u0645',
  Id: '\u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0631\u0641',
  'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.':
    '\u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0631\u0641 \u064a\u062c\u0628 \u0623\u0646 \u062a\u0628\u062f\u0623 \u0628\u062d\u0631\u0641\u060c \u064a\u062a\u0628\u0639 \u0641\u0642\u0637 \u0628\u062d\u0631\u0648\u0641 \u0648\u0623\u0631\u0642\u0627\u0645\u060c \u0634\u0631\u0637\u0627\u062a\u060c \u0623\u0648 \u0627\u0644\u0646\u0642\u0627\u0637\u060c \u0627\u0644\u0646\u0642\u0637\u062a\u064a\u0646 \u0623\u0648 \u0627\u0644\u0634\u0631\u0637\u0627\u062a \u0627\u0644\u0633\u0641\u0644\u064a\u0629.',
  'You have unsaved changes are you sure you want to navigate away?':
    '\u0644\u062f\u064a\u0643 \u062a\u063a\u064a\u064a\u0631\u0627\u062a \u0644\u0645 \u064a\u062a\u0645 \u062d\u0641\u0638\u0647\u0627 \u0647\u0644 \u0623\u0646\u062a \u0645\u062a\u0623\u0643\u062f \u0623\u0646\u0643 \u062a\u0631\u063a\u0628 \u0641\u064a \u0627\u0644\u0627\u0646\u062a\u0642\u0627\u0644 \u0628\u0639\u064a\u062f\u0627\u061f',
  'Restore last draft':
    '\u0627\u0633\u062a\u0639\u0627\u062f\u0629 \u0623\u062e\u0631 \u0645\u0633\u0648\u062f\u0629',
  'Special character': '\u0631\u0645\u0632',
  'Source code': '\u0634\u0641\u0631\u0629 \u0627\u0644\u0645\u0635\u062f\u0631',
  'Insert/Edit code sample':
    '\u0625\u062f\u0631\u0627\u062c/\u062a\u062d\u0631\u064a\u0631 \u0627\u0644\u0643\u0648\u062f',
  Language: '\u0627\u0644\u0644\u063a\u0629',
  'Code sample':
    '\u0639\u064a\u0651\u0646\u0629 \u0639\u0646 \u0627\u0644\u0643\u0648\u062f \u0627\u0644\u0628\u0631\u0645\u062c\u064a',
  Color: '\u0627\u0644\u0644\u0648\u0646',
  R: 'R',
  G: 'G',
  B: 'B',
  'Left to right': '\u0645\u0646 \u0627\u0644\u064a\u0633\u0627\u0631 \u0644\u0644\u064a\u0645\u064a\u0646',
  'Right to left': '\u0645\u0646 \u0627\u0644\u064a\u0645\u064a\u0646 \u0644\u0644\u064a\u0633\u0627\u0631',
  Emoticons: '\u0627\u0644\u0631\u0645\u0648\u0632',
  'Document properties': '\u062e\u0635\u0627\u0626\u0635 \u0627\u0644\u0645\u0633\u062a\u0646\u062f',
  Title: '\u0627\u0644\u0639\u0646\u0648\u0627\u0646',
  Keywords: '\u0643\u0644\u0645\u0627\u062a \u0627\u0644\u0628\u062d\u062b',
  Description: '\u0627\u0644\u0648\u0635\u0641',
  Robots: '\u0627\u0644\u0631\u0648\u0628\u0648\u062a\u0627\u062a',
  Author: '\u0627\u0644\u0643\u0627\u062a\u0628',
  Encoding: '\u0627\u0644\u062a\u0631\u0645\u064a\u0632',
  Fullscreen: '\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629',
  Action: '\u0627\u0644\u0639\u0645\u0644\u064a\u0629',
  Shortcut: '\u0627\u0644\u0627\u062e\u062a\u0635\u0627\u0631',
  Help: '\u0627\u0644\u0645\u0633\u0627\u0639\u062f\u0629',
  Address: '\u0627\u0644\u0639\u0646\u0648\u0627\u0646',
  'Focus to menubar':
    '\u0627\u0644\u062a\u0631\u0643\u064a\u0632 \u0639\u0644\u0649 \u0634\u0631\u064a\u0637 \u0627\u0644\u0642\u0648\u0627\u0626\u0645',
  'Focus to toolbar':
    '\u0627\u0644\u062a\u0631\u0643\u064a\u0632 \u0639\u0644\u0649 \u0634\u0631\u064a\u0637 \u0627\u0644\u0623\u062f\u0648\u0627\u062a',
  'Focus to element path':
    '\u0627\u0644\u062a\u0631\u0643\u064a\u0632 \u0639\u0644\u0649 \u0645\u0633\u0627\u0631 \u0627\u0644\u0639\u0646\u0635\u0631',
  'Focus to contextual toolbar':
    '\u0627\u0644\u062a\u0631\u0643\u064a\u0632 \u0639\u0644\u0649 \u0634\u0631\u064a\u0637 \u0623\u062f\u0648\u0627\u062a \u0627\u0644\u0633\u064a\u0627\u0642',
  'Insert link (if link plugin activated)':
    '\u0625\u0636\u0627\u0641\u0629 \u0631\u0627\u0628\u0637 (\u0625\u0630\u0627 \u0643\u0627\u0646\u062a \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0631\u0648\u0627\u0628\u0637 \u0645\u0641\u0639\u0644\u0629)',
  'Save (if save plugin activated)':
    '\u062d\u0641\u0638 (\u0625\u0630\u0627 \u0643\u0627\u0646\u062a \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u062d\u0641\u0638 \u0645\u0641\u0639\u0644\u0629)',
  'Find (if searchreplace plugin activated)':
    '\u0627\u0644\u0628\u062d\u062b (\u0625\u0630\u0627 \u0643\u0627\u0646\u062a \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0628\u062d\u062b \u0645\u0641\u0639\u0644\u0629)',
  'Plugins installed ({0}):':
    '\u0627\u0644\u0625\u0636\u0627\u0641\u0627\u062a \u0627\u0644\u0645\u062b\u0628\u062a\u0629 ({0}):',
  'Premium plugins:':
    '\u0627\u0644\u0625\u0636\u0627\u0641\u0627\u062a \u0627\u0644\u0645\u0645\u064a\u0632\u0629:',
  'Learn more...': '\u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0645\u0632\u064a\u062f...',
  'You are using {0}': '\u0623\u0646\u062a \u062a\u0633\u062a\u062e\u062f\u0645 {0}',
  Plugins: '\u0627\u0644\u0625\u0636\u0627\u0641\u0627\u062a',
  'Handy Shortcuts':
    '\u0627\u062e\u062a\u0635\u0627\u0631\u0627\u062a \u0645\u0633\u0627\u0639\u0650\u062f\u0629',
  'Horizontal line': '\u062e\u0637 \u0623\u0641\u0642\u064a',
  'Insert/edit image':
    '\u0625\u062f\u0631\u0627\u062c/\u062a\u062d\u0631\u064a\u0631 \u0635\u0648\u0631\u0629',
  'Image description': '\u0648\u0635\u0641 \u0627\u0644\u0635\u0648\u0631\u0629',
  Source: '\u0627\u0644\u0645\u0635\u062f\u0631',
  Dimensions: '\u0627\u0644\u0623\u0628\u0639\u0627\u062f',
  'Constrain proportions': '\u0627\u0644\u062a\u0646\u0627\u0633\u0628',
  General: '\u0639\u0627\u0645',
  Advanced: '\u062e\u0635\u0627\u0626\u0635 \u0645\u062a\u0642\u062f\u0645\u0647',
  Style: '\u0627\u0644\u0646\u0645\u0637 / \u0627\u0644\u0634\u0643\u0644',
  'Vertical space': '\u0645\u0633\u0627\u0641\u0629 \u0639\u0645\u0648\u062f\u064a\u0629',
  'Horizontal space': '\u0645\u0633\u0627\u0641\u0629 \u0623\u0641\u0642\u064a\u0629',
  Border: '\u062d\u062f\u0648\u062f',
  'Insert image': '\u0625\u062f\u0631\u0627\u062c \u0635\u0648\u0631\u0629',
  Image: '\u0627\u0644\u0635\u0648\u0631\u0629',
  'Image list': '\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0635\u0648\u0631',
  'Rotate counterclockwise':
    '\u062a\u062f\u0648\u064a\u0631 \u0639\u0643\u0633 \u0627\u062a\u062c\u0627\u0647 \u0639\u0642\u0627\u0631\u0628 \u0627\u0644\u0633\u0627\u0639\u0629',
  'Rotate clockwise':
    '\u062a\u062f\u0648\u064a\u0631 \u0641\u064a \u0627\u062a\u062c\u0627\u0647 \u0639\u0642\u0627\u0631\u0628 \u0627\u0644\u0633\u0627\u0639\u0629',
  'Flip vertically': '\u0627\u0646\u0639\u0643\u0627\u0633 \u0639\u0627\u0645\u0648\u062f\u064a',
  'Flip horizontally': '\u0627\u0646\u0639\u0643\u0627\u0633 \u0623\u0641\u0642\u064a',
  'Edit image': '\u062a\u062d\u0631\u064a\u0631 \u0627\u0644\u0635\u0648\u0631\u0629',
  'Image options': '\u0627\u0639\u062f\u0627\u062f\u0627\u062a \u0627\u0644\u0635\u0648\u0631\u0629',
  'Zoom in': '\u062a\u0643\u0628\u064a\u0631',
  'Zoom out': '\u062a\u0635\u063a\u064a\u0631',
  Crop: '\u0642\u0635',
  Resize: '\u062a\u063a\u064a\u064a\u0631 \u062d\u062c\u0645',
  Orientation: '\u0627\u0644\u0645\u062d\u0627\u0630\u0627\u0629',
  Brightness: '\u0627\u0644\u0625\u0636\u0627\u0621\u0629',
  Sharpen: '\u062d\u0627\u062f\u0629',
  Contrast: '\u0627\u0644\u062a\u0628\u0627\u064a\u0646',
  'Color levels': '\u0645\u0633\u062a\u0648\u0649 \u0627\u0644\u0644\u0648\u0646',
  Gamma: '\u063a\u0627\u0645\u0627',
  Invert: '\u0639\u0643\u0633',
  Apply: '\u062a\u0637\u0628\u064a\u0642',
  Back: '\u0644\u0644\u062e\u0644\u0641',
  'Insert date/time': '\u0625\u062f\u0631\u0627\u062c \u062a\u0627\u0631\u064a\u062e/\u0648\u0642\u062a',
  'Date/time': '\u0627\u0644\u062a\u0627\u0631\u064a\u062e/\u0627\u0644\u0648\u0642\u062a',
  'Insert link': '\u0625\u062f\u0631\u0627\u062c \u0631\u0627\u0628\u0637',
  'Insert/edit link':
    '\u0625\u062f\u0631\u0627\u062c/\u062a\u062d\u0631\u064a\u0631 \u0631\u0627\u0628\u0637',
  'Text to display':
    '\u0627\u0644\u0646\u0635 \u0627\u0644\u0645\u0637\u0644\u0648\u0628 \u0639\u0631\u0636\u0647',
  Url: '\u0627\u0644\u0639\u0646\u0648\u0627\u0646',
  Target: '\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0647\u062f\u0641',
  None: '\u0628\u0644\u0627',
  'New window': '\u0646\u0627\u0641\u0630\u0629 \u062c\u062f\u064a\u062f\u0629',
  'Remove link': '\u062d\u0630\u0641 \u0627\u0644\u0631\u0627\u0628\u0637',
  Anchors: '\u0627\u0644\u0645\u0631\u0633\u0627\u0629',
  Link: '\u0627\u0644\u0631\u0627\u0628\u0637',
  'Paste or type a link':
    '\u0623\u062f\u062e\u0644 \u0623\u0648 \u0627\u0643\u062a\u0628 \u0627\u0644\u0631\u0627\u0628\u0637',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?':
    '\u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064a \u0642\u0645\u062a \u0628\u0625\u062f\u0631\u0627\u062c\u0647 \u064a\u0634\u0627\u0628\u0647 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a. \u0647\u0644 \u062a\u0631\u064a\u062f \u0627\u0646 \u062a\u0636\u064a\u0641 \u0627\u0644\u0644\u0627\u062d\u0642\u0629 mailto: \u0645\u0639\u062a\u0628\u0631\u0627\u064b \u0647\u0630\u0627 \u0627\u0644\u0631\u0627\u0628\u0637 \u0628\u0631\u064a\u062f\u0627 \u0627\u0644\u0643\u062a\u0631\u0648\u0646\u064a\u0627\u064b\u061f',
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?':
    '\u0646\u062a\u0648\u0642\u0639 \u0627\u0646\u0643 \u0642\u0645\u062a \u0628\u0625\u062f\u0631\u0627\u062c \u0631\u0627\u0628\u0637 \u0644\u0645\u0648\u0642\u0639 \u062e\u0627\u0631\u062c\u064a. \u0647\u0644 \u062a\u0631\u064a\u062f \u0627\u0646 \u0646\u0636\u064a\u0641 \u0627\u0644\u0644\u0627\u062d\u0642\u0629 http:// \u0644\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0630\u064a \u0627\u062f\u062e\u0644\u062a\u0647\u061f',
  'Link list': '\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0631\u0648\u0627\u0628\u0637',
  'Insert video': '\u0625\u062f\u0631\u0627\u062c \u0641\u064a\u062f\u064a\u0648',
  'Insert/edit video':
    '\u0625\u062f\u0631\u0627\u062c/\u062a\u062d\u0631\u064a\u0631 \u0641\u064a\u062f\u064a\u0648',
  'Insert/edit media':
    '\u0625\u062f\u0631\u0627\u062c/\u062a\u062d\u0631\u064a\u0631 \u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u0645\u062a\u0639\u062f\u062f\u0629',
  'Alternative source': '\u0645\u0635\u062f\u0631 \u0628\u062f\u064a\u0644',
  Poster: '\u0645\u0644\u0635\u0642',
  'Paste your embed code below:':
    '\u0644\u0635\u0642 \u0643\u0648\u062f \u0627\u0644\u062a\u0636\u0645\u064a\u0646 \u0647\u0646\u0627:',
  Embed: '\u062a\u0636\u0645\u064a\u0646',
  Media: '\u0627\u0644\u0648\u0633\u0627\u0626\u0637 \u0627\u0644\u0645\u062a\u0639\u062f\u062f\u0629',
  'Nonbreaking space':
    '\u0645\u0633\u0627\u0641\u0629 \u063a\u064a\u0631 \u0645\u0646\u0642\u0633\u0645\u0629',
  'Page break': '\u0641\u0627\u0635\u0644 \u0644\u0644\u0635\u0641\u062d\u0629',
  'Paste as text': '\u0644\u0635\u0642 \u0643\u0646\u0635',
  Preview: '\u0645\u0639\u0627\u064a\u0646\u0629',
  Print: '\u0637\u0628\u0627\u0639\u0629',
  Save: '\u062d\u0641\u0638',
  Find: '\u0628\u062d\u062b',
  'Replace with': '\u0627\u0633\u062a\u0628\u062f\u0627\u0644 \u0628\u0640',
  Replace: '\u0627\u0633\u062a\u0628\u062f\u0627\u0644',
  'Replace all': '\u0627\u0633\u062a\u0628\u062f\u0627\u0644 \u0627\u0644\u0643\u0644',
  Prev: '\u0627\u0644\u0633\u0627\u0628\u0642',
  Next: '\u0627\u0644\u062a\u0627\u0644\u064a',
  'Find and replace': '\u0628\u062d\u062b \u0648\u0627\u0633\u062a\u0628\u062f\u0627\u0644',
  'Could not find the specified string.':
    '\u062a\u0639\u0630\u0631 \u0627\u0644\u0639\u062b\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u062d\u062f\u062f\u0629',
  'Match case':
    '\u0645\u0637\u0627\u0628\u0642\u0629 \u062d\u0627\u0644\u0629 \u0627\u0644\u0623\u062d\u0631\u0641',
  'Whole words':
    '\u0645\u0637\u0627\u0628\u0642\u0629 \u0627\u0644\u0643\u0644\u0645\u0627\u062a \u0628\u0627\u0644\u0643\u0627\u0645\u0644',
  Spellcheck: '\u062a\u062f\u0642\u064a\u0642 \u0625\u0645\u0644\u0627\u0626\u064a',
  Ignore: '\u062a\u062c\u0627\u0647\u0644',
  'Ignore all': '\u062a\u062c\u0627\u0647\u0644 \u0627\u0644\u0643\u0644',
  Finish: '\u0627\u0646\u062a\u0647\u064a',
  'Add to Dictionary': '\u0627\u0636\u0641 \u0627\u0644\u064a \u0627\u0644\u0642\u0627\u0645\u0648\u0633',
  'Insert table': '\u0625\u062f\u0631\u0627\u062c \u062c\u062f\u0648\u0644',
  'Table properties': '\u062e\u0635\u0627\u0626\u0635 \u0627\u0644\u062c\u062f\u0648\u0644',
  'Delete table': '\u062d\u0630\u0641 \u062c\u062f\u0648\u0644',
  Cell: '\u062e\u0644\u064a\u0629',
  Row: '\u0635\u0641',
  Column: '\u0639\u0645\u0648\u062f',
  'Cell properties': '\u062e\u0635\u0627\u0626\u0635 \u0627\u0644\u062e\u0644\u064a\u0629',
  'Merge cells': '\u062f\u0645\u062c \u062e\u0644\u0627\u064a\u0627',
  'Split cell': '\u062a\u0642\u0633\u064a\u0645 \u0627\u0644\u062e\u0644\u0627\u064a\u0627',
  'Insert row before': '\u0625\u062f\u0631\u0627\u062c \u0635\u0641 \u0644\u0644\u0623\u0639\u0644\u0649',
  'Insert row after': '\u0625\u062f\u0631\u0627\u062c \u0635\u0641 \u0644\u0644\u0623\u0633\u0641\u0644',
  'Delete row': '\u062d\u0630\u0641 \u0635\u0641',
  'Row properties': '\u062e\u0635\u0627\u0626\u0635 \u0627\u0644\u0635\u0641',
  'Cut row': '\u0642\u0635 \u0627\u0644\u0635\u0641',
  'Copy row': '\u0646\u0633\u062e \u0627\u0644\u0635\u0641',
  'Paste row before': '\u0644\u0635\u0642 \u0627\u0644\u0635\u0641 \u0644\u0644\u0623\u0639\u0644\u0649',
  'Paste row after': '\u0644\u0635\u0642 \u0627\u0644\u0635\u0641 \u0644\u0644\u0623\u0633\u0641\u0644',
  'Insert column before':
    '\u0625\u062f\u0631\u0627\u062c \u0639\u0645\u0648\u062f \u0644\u0644\u064a\u0633\u0627\u0631',
  'Insert column after':
    '\u0625\u062f\u0631\u0627\u062c \u0639\u0645\u0648\u062f \u0644\u0644\u064a\u0645\u064a\u0646',
  'Delete column': '\u062d\u0630\u0641 \u0639\u0645\u0648\u062f',
  Cols: '\u0639\u062f\u062f \u0627\u0644\u0623\u0639\u0645\u062f\u0629',
  Rows: '\u0639\u062f\u062f \u0627\u0644\u0635\u0641\u0648\u0641',
  Width: '\u0639\u0631\u0636',
  Height: '\u0627\u0631\u062a\u0641\u0627\u0639',
  'Cell spacing':
    '\u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0628\u064a\u0646 \u0627\u0644\u062e\u0644\u0627\u064a\u0627',
  'Cell padding': '\u062a\u0628\u0627\u0639\u062f \u0627\u0644\u062e\u0644\u064a\u0629',
  Caption: '\u0634\u0631\u062d',
  Left: '\u064a\u0633\u0627\u0631',
  Center: '\u062a\u0648\u0633\u064a\u0637',
  Right: '\u064a\u0645\u064a\u0646',
  'Cell type': '\u0646\u0648\u0639 \u0627\u0644\u062e\u0644\u064a\u0629',
  Scope: '\u0627\u0644\u0645\u062c\u0627\u0644',
  Alignment: '\u0645\u062d\u0627\u0630\u0627\u0629',
  'H Align': '\u0645\u062d\u0627\u0630\u0627\u0629 \u0623\u0641\u0642\u064a\u0629',
  'V Align': '\u0645\u062d\u0627\u0630\u0627\u0629 \u0631\u0623\u0633\u064a\u0629',
  Top: '\u0623\u0639\u0644\u064a',
  Middle: '\u0627\u0644\u0648\u0633\u0637',
  Bottom: '\u0627\u0644\u0623\u0633\u0641\u0644',
  'Header cell': '\u0631\u0623\u0633 \u0627\u0644\u062e\u0644\u064a\u0629',
  'Row group': '\u0645\u062c\u0645\u0648\u0639\u0629 \u0635\u0641',
  'Column group': '\u0645\u062c\u0645\u0648\u0639\u0629 \u0639\u0645\u0648\u062f',
  'Row type': '\u0646\u0648\u0639 \u0627\u0644\u0635\u0641',
  Header: '\u0627\u0644\u0631\u0623\u0633',
  Body: '\u0647\u064a\u0643\u0644',
  Footer: '\u062a\u0630\u064a\u064a\u0644',
  'Border color': '\u0644\u0648\u0646 \u0627\u0644\u0625\u0637\u0627\u0631',
  'Insert template': '\u0625\u062f\u0631\u0627\u062c \u0642\u0627\u0644\u0628',
  Templates: '\u0642\u0648\u0627\u0644\u0628',
  Template: '\u0627\u0644\u0642\u0627\u0644\u0628',
  'Text color': '\u0644\u0648\u0646 \u0627\u0644\u0646\u0635',
  'Background color': '\u0644\u0648\u0646 \u0627\u0644\u062e\u0644\u0641\u064a\u0629',
  'Custom...': '\u062a\u062e\u0635\u064a\u0635 ...',
  'Custom color': '\u0644\u0648\u0646 \u0645\u062e\u0635\u0635',
  'No color': '\u0628\u062f\u0648\u0646 \u0644\u0648\u0646',
  'Table of Contents': '\u062c\u062f\u0648\u0644 \u0627\u0644\u0645\u062d\u062a\u0648\u064a\u0627\u062a',
  'Show blocks': '\u0645\u0634\u0627\u0647\u062f\u0629 \u0627\u0644\u0643\u062a\u0644',
  'Show invisible characters':
    '\u0623\u0638\u0647\u0631 \u0627\u0644\u0623\u062d\u0631\u0641 \u0627\u0644\u063a\u064a\u0631 \u0645\u0631\u0626\u064a\u0629',
  'Words: {0}': '\u0627\u0644\u0643\u0644\u0645\u0627\u062a:{0}',
  '{0} words': '{0} \u0643\u0644\u0645\u0627\u062a',
  File: '\u0645\u0644\u0641',
  Edit: '\u062a\u062d\u0631\u064a\u0631',
  Insert: '\u0625\u062f\u0631\u0627\u062c',
  View: '\u0639\u0631\u0636',
  Format: '\u062a\u0646\u0633\u064a\u0642',
  Table: '\u062c\u062f\u0648\u0644',
  Tools: '\u0623\u062f\u0627\u0648\u0627\u062a',
  'Powered by {0}': '\u0645\u062f\u0639\u0648\u0645 \u0645\u0646 {0}',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help':
    '\u0645\u0646\u0637\u0642\u0629 \u0646\u0635 \u0645\u0646\u0633\u0642. \u0627\u0636\u063a\u0637 ALT-F9 \u0644\u0644\u0642\u0627\u0626\u0645\u0629. \u0627\u0636\u063a\u0637 ALT-F10 \u0644\u0634\u0631\u064a\u0637 \u0627\u0644\u0623\u062f\u0648\u0627\u062a. \u0627\u0636\u063a\u0637 ALT-0 \u0644\u0644\u062d\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u0633\u0627\u0639\u062f\u0629',
  _dir: 'rtl',
});
